import axios from 'helpers/axios';

/**
 * Таблица скоринга
 */
export const getScoring = async ({ queryKey }) => {
    const [, revision, search, curatorFilter, perPage, page] = queryKey;
    const offset = page ? Math.ceil(Number(page) * Number(perPage)) : null;

    let params = new URLSearchParams();

    if (search) {
        params.append('name', search);
    }

    if (curatorFilter) {
        params.append('curatorId', curatorFilter.id);
    }

    if (perPage) {
        params.append("limit", perPage);
    }

    if (offset) {
        params.append("offset", String(offset));
    }

    const request = {
        params: params,
    };

    if (revision && revision.id) {
        const { data } = await axios.get(`/api/adminapi/analytics/players/scoring/revisions/${revision.id}/stats/`, request);

        return data;
    }
};

/**
 * Список ревизий
 */
export const getRevision = async () => {
    const { data } = await axios.get(`/api/adminapi/analytics/players/scoring/revisions/`);

    return data;
};

/**
 * Скачивание csv
 */
export const getScoringCsv = async ({ revisionId }) => {
    const { data } = await axios.get(`/api/adminapi/analytics/players/scoring/revisions/${revisionId}/csv/`);

    return data;
};